import React from 'react';
import { BsFillFileEarmarkCheckFill } from 'react-icons/bs';
import { FaSpinner } from 'react-icons/fa';

const PreparingOrderComponent = () => {
    return (
        <div className="flex justify-center items-center h-full py-6">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center max-w-sm transform transition-all duration-300 hover:shadow-xl">
                <div className="flex justify-center text-5xl mb-6 text-green-500 animate-pulse">
                    <BsFillFileEarmarkCheckFill />
                </div>
                <h2 className="text-xl font-semibold text-gray-800 mb-3">Order in Progress</h2>
                <p className="text-gray-600 leading-relaxed">
                    Your order has been accepted and is currently being prepared. We'll notify you once it's ready.
                </p>
                <div className="mt-6 flex justify-center">
                    <FaSpinner className="text-green-500 text-2xl animate-spin" />
                </div>
            </div>
        </div>
    );
}

export default PreparingOrderComponent;
